import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Alert
} from '@mui/material';
import PhoneNumberField from '../../../common/PhoneNumberField';
 
const SendMessageButton = ({ handleSendMessage, phoneNumber, setPhoneNumber, 
  message, setMessage, snackbar, setSnackbar }) => {
  const [errors, setErrors] = useState({
    phoneNumber: false,
    message: false
  });

  // Local state for dialog open/close
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };
  
  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    return phoneRegex.test(phone);
  };
 
  const validateAndSend = () => {
    const newErrors = {
      phoneNumber: !phoneNumber.trim() || !validatePhoneNumber(phoneNumber),
      message: !message.trim()
    };
   
    setErrors(newErrors);
   
    if (!newErrors.phoneNumber && !newErrors.message) {
      handleSendMessage();
      handleDialogClose(); // ✅ close dialog after sending
    }
  };
 
  const handleCancel = () => {
    // Clear fields
    setPhoneNumber('');
    setMessage('');
    // Clear errors
    setErrors({
      phoneNumber: false,
      message: false
    });
    // Close dialog
    handleDialogClose();
  };
  
  // Format phone number as user types
  const handlePhoneNumberChange = (e) => {
    let input = e.target.value.replace(/\D/g, ''); // Remove non-digits
    
    // Format with dashes (000-000-0000)
    if (input.length > 3) {
      input = input.slice(0, 3) + '-' + input.slice(3);
    }
    if (input.length > 7) {
      input = input.slice(0, 7) + '-' + input.slice(7);
    }
    
    if (input.length > 12) {
      input = input.slice(0, 12);
    }
    
    setPhoneNumber(input);
    if (input.trim()) {
      setErrors(prev => ({...prev, phoneNumber: !validatePhoneNumber(input)}));
    } else {
      setErrors(prev => ({...prev, phoneNumber: false}));
    }
  };

  const handleMessageChange = (e) => {
    const input = e.target.value;
    if (input.length <= 150) {
      setMessage(input);
      if (input.trim()) {
        setErrors(prev => ({...prev, message: false}));
      }
    }
  };
 
  return (
    <>
      <Button
        onClick={handleDialogOpen}
        variant="outlined"
        sx={{ marginTop: '30px', marginLeft: '18px', textTransform: 'none', fontSize: '15px' }}
      >
        Send Message
      </Button>
            
      <Dialog 
        open={isDialogOpen}
        onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleDialogClose(event, reason);
        }}
        maxWidth="sm"
        fullWidth
        disableScrollLock={true}
        keepMounted={false}
        hideBackdrop={false}
        style={{ zIndex: 1300 }}
      >
        <DialogTitle
        >
          Send Message
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '100%',
              marginTop: 2,
            }}
          >
           
            <PhoneNumberField
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              // placeholder="000-000-0000"
              fullWidth
              margin="dense"
              // error={errors.phoneNumber}
              // helperText={errors.phoneNumber ? "Phone number must be in format 000-000-0000" : ""}
              inputProps={{
                maxLength: 12
              }}
              labelStyle={{ fontSize: 16, fontWeight: 500,mb:1}}
            />
            <Typography variant="body1" sx={{ marginTop: 2 }}>
              Message
            </Typography>
            <TextField
              value={message}
              onChange={handleMessageChange}
              placeholder="Enter your message here (max 150 characters)"
              fullWidth
              margin="dense"
              multiline
              rows={4}
              error={errors.message}
              helperText={errors.message ? "Message is required" : `${message.length}/150 characters`}
              inputProps={{
                maxLength: 150
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{marginBottom: "20px", marginRight:"15px"}}>
          <Button 
            onClick={handleCancel} 
            variant="outlined"
            sx={{textTransform: 'none', fontSize: '15px'}}
            size="large"
          >
            Cancel
          </Button>
          <Button 
            onClick={validateAndSend} 
            size="large"
            variant="outlined"
            sx={{textTransform: 'none', fontSize: '15px'}}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
 
      {/* Snackbar for Message Status */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};
 
export default SendMessageButton;
